import UserPermission, { UserPermissionStrings } from 'enums/UserPermission'
import UserRole, { UserRoleStrings } from 'enums/UserRole'

export function hasPermission(
  requiredPermissions: UserPermissionStrings[],
  ownedPermissions: UserPermissionStrings[] = []
) {
  return !requiredPermissions.find((permission) => !ownedPermissions.includes(permission))
}

export function hasInternalAnalysisPermission(ownedPermissions: UserPermissionStrings[]) {
  return hasPermission([UserPermission.PERMS_INTERNAL_ANALYSIS], ownedPermissions)
}

export function hasLiveReportPermission(ownedPermissions: UserPermissionStrings[]) {
  return hasPermission([UserPermission.PERMS_MANAGE_LIVE_REPORT], ownedPermissions)
}

export function hasManagementDashboardPermission(ownedPermissions: UserPermissionStrings[]) {
  return hasPermission([UserPermission.PERMS_MANAGE_DASHBOARD], ownedPermissions)
}

export function hasExportPdfPermission(ownedPermissions: UserPermissionStrings[]) {
  return hasPermission([UserPermission.PERMS_EXPORT_PDF], ownedPermissions)
}

export const USER_ROLE_ORDER = [
  UserRole.ROLE_PRO_USER,
  UserRole.ROLE_ANNOTATOR,
  UserRole.ROLE_BUSINESS_USER,
  UserRole.ROLE_EXECUTIVE,
  UserRole.ROLE_BASIC_USER,
  UserRole.ROLE_ACCOUNT_ADMIN_USER,
  UserRole.ROLE_COMPANY_ADMIN_USER,
  UserRole.ROLE_SELLER_ADMIN_USER,
  UserRole.ROLE_INTEGRATION_USER,
  UserRole.ROLE_SUPPORT_ADMIN_USER,
  UserRole.ROLE_SYSTEM_ADMIN_USER
]

export function isRoleGreaterThanOrEq(ownRole?: UserRoleStrings, specificRole?: UserRoleStrings) {
  if (!ownRole || !specificRole) return false
  return USER_ROLE_ORDER.indexOf(ownRole) >= USER_ROLE_ORDER.indexOf(specificRole)
}

export function getHighestRole(roles: UserRoleStrings[]): UserRoleStrings | undefined {
  // @ts-ignore: findLast
  return USER_ROLE_ORDER.findLast((role: UserRoleStrings) => roles.includes(role))
}
